import React, { useState } from "react";
import rrwebPlayer from "rrweb-player";
import "rrweb-player/dist/style.css";

const ReplayRecording = () => {
  const [bearerToken, setBearerToken] = useState(localStorage.getItem("bearerToken") || "");
  const [showTokenInput, setShowTokenInput] = useState(!localStorage.getItem("bearerToken"));
  const [error, setError] = useState(null);
  const [operatorId, setOperatorId] = useState("");
  const [player, setPlayer] = useState(null);

  const handleTokenSubmit = () => {
    localStorage.setItem("bearerToken", bearerToken);
    setShowTokenInput(false);
  };

  if (showTokenInput) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div
          className={`bg-white rounded-lg border border-gray-200 w-full max-w-md p-8`}
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Enter Bearer Token
          </h2>
          <input
            type="text"
            value={bearerToken}
            onChange={(e) => setBearerToken(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md mb-4"
            placeholder="Bearer token"
          />
          <button
            className={`px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors`}
            onClick={handleTokenSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  const fetchRecording = async () => {
    setError(null);
    if (player) {
        const replayer = player.getReplayer(); // Get the internal rrweb Replayer instance
        if (replayer) {
          replayer.pause(); // Pause if playing
        }
        replayer.destroy();
        document.getElementById("player").innerHTML = ""; // Remove from DOM  
        setPlayer(null); // Clear state  
      }
      
    if (!operatorId) {
      alert("Please enter an Operator ID.");
      return;
    }
    const response = await fetch(`/scout/${operatorId}/get-recording`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    if (response.ok) {
      const data = await response.json();

      const newPlayer = new rrwebPlayer({
        target: document.getElementById("player"),
        props: {
          events: data,
          width: 853, // Player width in pixels
          height: 480, // Player height in pixels
          skipInactive: false, // Skip inactive time periods
          showController: true, // Show playback controls
          autoPlay: true, // Start playing automatically
        },
      });

      setPlayer(newPlayer); // Store the player instance in state
    } else {
      const errorData = await response.json();
      setError(
        typeof errorData.detail === "string"
          ? errorData.detail
          : "Failed to fetch operators"
      );
    }
  };

  return (
    <div className="flex flex-col items-center w-full min-h-screen p-6 bg-gray-100">
      {/* Title */}
      <p className="text-2xl font-semibold mb-6">Session Replay</p>

      {/* Form Section */}
      <div className="flex items-center gap-3 mb-6">
        <label htmlFor="operator-id" className="text-base font-medium">
          Operator ID:
        </label>
        <input
          type="number"
          name="operator-id"
          id="operator-id"
          className="w-32 rounded-md border border-gray-300 px-3 py-1 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter ID"
          value={operatorId}
          onChange={(e) => setOperatorId(e.target.value)}
        />
        <button
          type="button"
          id="fetch-video-button"
          className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm px-4 py-2"
          onClick={fetchRecording}
        >
          Fetch Video
        </button>
      </div>

      {/* Empty Space for Player */}
      <div id="player" className="mt-2">
        {error ? (
          <div className="p-8 text-center text-red-600">{error}</div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ReplayRecording;
